<template>
  <div class="empty-page">
    <img :src="img" alt="empty-icon" :width="imgInfo.width" :height="imgInfo.height" />
    <p>{{ text }}</p>
    <slot>
      <Button type="primary" :icon="btnIcon" @click="handleClick">{{ btnText }}</Button>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'Emptypage',

  props: {
    img: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    btnText: {
      type: String,
      default: '',
    },
    btnIcon: {
      type: String,
      default: 'md-add',
    },
    imgInfo: {
      type: Object,
      default: () => ({ width: 230, height: 220 }),
    },
  },

  data() {
    return {}
  },

  methods: {
    handleClick() {
      this.$emit('onClick')
    },
  },
}
</script>

<style lang="scss">
.empty-page {
  padding-top: 100px;
  text-align: center;
  p {
    color: var(--color-text-title);
    margin: 20px auto 32px;
    font-size: 14px;
    max-width: 350px;
    text-align: center;
  }
}
</style>
